/* eslint-disable react/prop-types */
import React from "react";
import {
  makeStyles,
  Tooltip,
  Box,
  Typography,
  useMediaQuery,
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  button: {
    textTransform: "none",
    flex: 1,
    padding: "4px 40px",
    backgroundColor: "white",
    color: "#6A6A6A",
    borderRadius: "7px 7px 0px 0px",
    marginRight: "8px",
  },
  buttonSmall: {
    textTransform: "none",
    flex: 1,
    padding: "4px 27px",
    backgroundColor: "white",
    color: "#6A6A6A",
    borderRadius: "7px 7px 0px 0px",
    marginRight: "8px",
  },
  disabledButton: {
    textTransform: "none",
    flex: 1,
    padding: "4px 40px",
    backgroundColor: "#CCCCCC",
    color: "#6A6A6A",
    borderRadius: "7px 7px 0px 0px",
  },
  disabledButtonSmall: {
    textTransform: "none",
    flex: 1,
    padding: "4px 27px",
    backgroundColor: "#CCCCCC",
    color: "#6A6A6A",
    borderRadius: "7px 7px 0px 0px",
  },
  container: {
    display: "flex",
    marginTop: "15px",
  },
  elasticityTypeTittle: {
    display: "flex",
    alignItems: "center",
  },
}));

const ElasticityTypeToggle = () => {
  const classes = useStyles();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Box className={classes.container}>
      <div className={isSmallScreen ? classes.buttonSmall : classes.button}>
        <Typography
          variant={isSmallScreen ? "caption" : "body1"}
          className={classes.elasticityTypeTittle}
        >
          Own Elasticities
        </Typography>
      </div>
      <Tooltip title="Available soon" placement="right">
        <div
          className={
            isSmallScreen ? classes.disabledButtonSmall : classes.disabledButton
          }
        >
          <Typography
            variant={isSmallScreen ? "caption" : "body1"}
            className={classes.elasticityTypeTittle}
          >
            Cross Elasticities
          </Typography>
        </div>
      </Tooltip>
    </Box>
  );
};

export default ElasticityTypeToggle;
